import React, { memo } from "react";
import "../styles/EpcServicesGrid.css";

const EpcServicesGrid = ({ services = [] }) => {
  return (
    <div className="epc-services-grid">
      {services.map((item, i) => (
        <div className="epc-service-card" key={i}>
          <div className="epc-card-header">
            <div className="epc-icon">{item.icon}</div>
            <span className="epc-service-title">{item.text}</span>
          </div>
          {item.points && (
            <ul className="epc-service-points">
              {item.points.map((p, j) => <li key={j}>{p}</li>)}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default memo(EpcServicesGrid);
